<template>
  <div class="homepage-topics">
    <div class="main-topics">
      <div class="main-title">
        <h2 class="title">精选专题</h2>
        <h3 class="subtitle">我们是航海家,更是梦想家</h3>
      </div>
      <ul class="list-topics">
        <li v-for="(item, i) in promoBanners" :key="i">
          <a
            :href="item.linkUrl"
            target="_blank"
            :data-growing-title="getGioTitle(i)"
						@click="onTopicClicked(i, item.linkUrl)"
          >
            <img :src="item.image" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import { gioAdsTracking } from "@/utilities/tools";
export default {
  name: "HomeTopic",
  props: {
    promoBanners: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    getGioTitle(i) {
      let growingIOTitle = "";
      if (i == 0) {
        growingIOTitle = "左2";
      } else if (i == 1) {
        growingIOTitle = "中2";
      } else if (i == 2) {
        growingIOTitle = "右2";
      }
      return growingIOTitle;
    },
		onTopicClicked (index, url) {
			const eventObject = {
				"adsType": "ch",
				"chOrder": index+1,
				"desUrl": url
			}
			gioAdsTracking(eventObject);
		}
  },
  computed: {},
};
</script>

<style scoped>
</style>